import RestClientService from "@/core/services/restClient.service";
import notificationService from "@/core/services/notification.service";
import { NOTIFICATION_TYPES } from "@/core/enums/NOTIFICATION_TYPES";
import { NOTIFICATION_MESSAGES } from "@/core/constants/notificationMessages";
import { MY_ISSUANCE_API_PATH } from "@/modules/MyIssuances/constants";
import { FetchBookingsParamsRequestModel } from "@/modules/MyBookings/models/fetchBookingsParams.request";
import { CACHE_NAMES } from "@/core/constants";
import { IMyFlightIssuance } from "@/core/interfaces/myIssuance.interface";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";

class MyIssuanceService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public async fetchMyIssuance(
    payload: FetchBookingsParamsRequestModel,
    isFetchNewData: boolean,
  ): Promise<IMyFlightIssuance> {
    let mappedFlightBookings: IMyFlightIssuance = {
      count: 0,
      next: "",
      previous: "",
      bookings: [],
    };
    try {
      if (isFetchNewData) {
        await caches.delete(CACHE_NAMES.flightsBookings);
      }
      const response = await this.restClient.get(
        MY_ISSUANCE_API_PATH.GET_ISSUANCE_LIST,
        payload,
      );
      if (response.success && response.data) {
        mappedFlightBookings = response.data;
      } else {
        notificationService.type = NOTIFICATION_TYPES.ERROR;
        notificationService.description =
          response.message || response.error || NOTIFICATION_MESSAGES.DEFAULT;
        notificationService.triggerNotification();
      }
    } catch (err) {
      console.error("Error in getMyIssuances:", err);
    }
    return mappedFlightBookings;
  }
  public getMyIssuanceDetail(
    issuanceId: string,
    organizationId: string,
  ): Promise<ICoreResponse> {
    return this.restClient.get(
      MY_ISSUANCE_API_PATH.GET_ISSUANCE_DETAILS +
        issuanceId +
        "/" +
        "?organization=" +
        organizationId,
    );
  }
}

export default MyIssuanceService;
